import { Component, Input, OnChanges, OnDestroy, signal, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { CargaDocumentosService } from 'src/app/Services/carga-documentos.service';

@Component({
  selector: 'app-pdfviewer',
  templateUrl: './pdfviewer.component.html',
  styleUrls: ['./pdfviewer.component.css']
})
export class PDFViewerComponent implements OnChanges, OnDestroy {
  @Input() url: string = '';
  pdfSrc: string | null = null;
  currentPdf = signal<string>('');
  zoom = 1;
  page = 1;
  private sub?: Subscription;
  public bigFile: boolean = false;
  constructor(private cargaDocumentosService: CargaDocumentosService,) {

  }

  ngOnChanges(changes: SimpleChanges): void {

    if (!this.url) return;

    // Cancelar suscripción anterior si existe
    this.sub?.unsubscribe();

    this.sub = this.cargaDocumentosService.getUrlPdf(this.url)
      .subscribe((base64: string) => {

        if (base64.length > 0) {
          const blob = this.base64ToBlob(base64);
          this.pdfSrc = URL.createObjectURL(blob);

        }
        else {
          let newUrl = this.url.replace('base64', 'url_presigned');

          this.cargaDocumentosService.getUrlFile(newUrl).subscribe(
            {
              next: (respuesta) => {

                console.log(respuesta);
                this.pdfSrc = respuesta.data;

                this.bigFile = true;

              },
              error: (error: any) => {
                console.log(error);
              }
            }
          );

        }

      });
  }

  private base64ToBlob(base64: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();

    if (this.pdfSrc) {
      URL.revokeObjectURL(this.pdfSrc); // 🔥 liberar memoria
    }
  }

  zoomIn() {
    this.zoom += 0.25;
  }

  zoomOut() {
    if (this.zoom > 0.5) this.zoom -= 0.25;
  }

  nextPage() {
    this.page++;
  }

  prevPage() {
    if (this.page > 1) this.page--;
  }

  downloadPdf() {
    if (!this.pdfSrc) return;

    const link = document.createElement('a');
    link.href = this.pdfSrc;
    link.download = 'archivo.pdf';
    link.click();
  }
}
